import React from 'react';
import radium from 'radium';
import landscapeImage from '../../static/images/comparisons_landscape.jpg';
import portraitImage from '../../static/images/comparisons_portrait.jpg';

const styles = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 150px)',
    padding: 20,
  },
  image: {
    maxWidth: '100%',
    maxHeight: 'calc(100% - 60px)',
    display: 'none',
  },
  landscape: {
    '@media (min-width: 1024px)': {
      display: 'block',
    },
  },
  portrait: {
    '@media (max-width: 1023px)': {
      display: 'block',
    },
  },
};

function Comparisons() {
  return (
    <div style={styles.wrap}>
      <img role="presentation" src={landscapeImage} style={[styles.image, styles.landscape]} />
      <img role="presentation" src={portraitImage} style={[styles.image, styles.portrait]} />
    </div>
  );
}

export default radium(Comparisons);



// WEBPACK FOOTER //
// ./components/Comparisons/Comparisons.js